import butterCategoryCoverImage from '../../../assets/images/butter/butterCategoryCoverImage.webp'
import butterImage1 from '../../../assets/images/butter/butter-extra-82-5-fat-pastoral-200g.webp'
import butterImage2 from '../../../assets/images/butter/butter-selyanske-72-5-fat-pastoral-200g.webp'
import gheeImage from '../../../assets/images/butter/ghee-99-fat-pastoral-200g.webp'
import butterCategoryCoverImageMobile from '../../../assets/images/butter/butterCategoryCoverImageMobile.webp'

export const ButterProductsArrRu = [
    {
        path: "/ru/butter/butter-extra-82-5-fat-pastoral-200g/",
        category: "butter",
        // КАТЕГОРЮ НЕ ТРОГАТЬ
        metaTitle: "Сливочное масло экстра 82,5% жирности ТМ «Pastoral» 200 g (г)",
        metaDescription: "Сливочное масло экстра 82,5% жирности ТМ «Pastoral» 200 g (г)",
        coverImage: butterCategoryCoverImage,
        coverImageMobile: butterCategoryCoverImageMobile,
        coverTitle: "Масло сливочное",
        aboutImage: butterImage1,
        aboutTitle: "Сливочное масло экстра 82,5% жирности ТМ «Pastoral» 200 g (г)",
        aboutStats: [
            "0,5 g (г)", "82,5 g (г)", "0,8 g (г)", "748 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Масса/Объём: ",
                desc: "200 g (г)",
            },
            {
                title: "Упаковка: ",
                desc: "фольга",
            },
            {
                title: "Состав: ",
                desc: "сливки из коровьего молока",
            },
            {
                title: "Срок годности: ",
                desc: (
                    <>от 0°С до -5°С — 3 месяца; от -6°С до -11°С — 9 месяцев; от -12°С до -18°С — 12 месяцев — для монолита; <br/> от 0°С до -5°С — 35 суток; от -6°С до -11°С — 60 суток; от -12°С до -18°С — 75 суток — для фасованного продукта </>
                ),

            },
            {
                title: "Сертификат качества: ",
                desc: "ДСТУ 4399:2005",
            },
        ],
        categoryInfo: [
            "Изготовлено из 100% натуральных сливок.",
            "Европейская технология взбивания для идеальной текстуры",
            "Без добавления искусственных консервантов и добавок.",
            "Натуральный источник белка, витаминов для красоты и здоровья",
    
        ],
    },
    {
        path: "/ru/butter/butter-selyanske-72-5-fat-pastoral-200g/",
        category: "butter",
        metaTitle: "Сливочное масло селянское 72,5% жирности ТМ «Pastoral» 200 g (г)",
        metaDescription: "Сливочное масло селянское 72,5% жирности ТМ «Pastoral» 200 g (г)",
        coverImage: butterCategoryCoverImage,
        coverImageMobile: butterCategoryCoverImageMobile,
        coverTitle: "Масло сливочное",
        aboutImage: butterImage2,
        aboutTitle: "Сливочное масло селянское 72,5% жирности ТМ «Pastoral» 200 g (г)",
        aboutStats: [
            "0,8 g (г)", "72,5 g (г)", "1,3 g (г)", "661 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Масса/Объём: ",
                desc: "200 g (г)",
            },
            {
                title: "Упаковка: ",
                desc: "фольга",
            },
            {
                title: "Состав: ",
                desc: "сливки из коровьего молока",
            },
            {
                title: "Срок годности: ",
                desc: (
                    <>от 0°С до -5°С — 3 месяца; от -6°С до -11°С — 9 месяцев; от -12°С до -18°С — 12 месяцев — для монолита <br/> от 0°С до -5°С — 35 суток; от -6°С до -11°С — 60 суток; от -12°С до -18°С — 75 суток — для фасованного продукта </>
                ),

            },
            {
                title: "Сертификат качества: ",
                desc: "ДСТУ 4399:2005",
            },
        ],
        categoryInfo: [
            "Изготовлено из 100% натуральных сливок.",
            "Европейская технология взбивания для идеальной текстуры",
            "Без добавления искусственных консервантов и добавок.",
            "Натуральный источник белка, витаминов для красоты и здоровья",
    
        ],
    },
    {
        path: "/ru/butter/ghee-99-fat-pastoral-200g/",
        category: "butter",
        metaTitle: "Топлёное масло 99,0% жирности ТМ «Pastoral» масло ГХИ 200 g (г)",
        metaDescription: "Топлёное масло 99,0% жирности ТМ «Pastoral» масло ГХИ 200 g (г)",
        coverImage: butterCategoryCoverImage,
        coverImageMobile: butterCategoryCoverImageMobile,
        coverTitle: "Масло сливочное",
        aboutImage: gheeImage,
        aboutTitle: "Топлёное масло 99,0% жирности ТМ «Pastoral» масло ГХИ 200 g (г)",
        aboutStats: [
            "0,1 g (г)", "99 g (г)", "0,3 g (г)", "892 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Масса/Объём: ",
                desc: "500 g (г)",
            },
            {
                title: "Упаковка: ",
                desc: "стекло",
            },
            {
                title: "Состав: ",
                desc: "сливочное масло",
            },
            {
                title: "Срок годности: ",
                desc: (
                    <>от 0°С до -5°С — 2 месяца; от -6°С до -11°С — 3 месяца; от -12°С до -18°С — 4 месяца</>
                ),

            },
            {
                title: "Сертификат качества: ",
                desc: "ДСТУ 4399:2005",
            },
        ],
        categoryInfo: [
            "Изготовлено из 100% натуральных сливок.",
            "Европейская технология взбивания для идеальной текстуры",
            "Без добавления искусственных консервантов и добавок.",
            "Натуральный источник белка, витаминов для красоты и здоровья",
    
        ],
    },
]
